module.exports = __webpack_public_path__ + "static/WEDDING E&M-374-ae363be06c56f51eaa802cc1ca1514aa.jpg";